import React, { useState } from "react";
import { PublisherLogoSquare2 } from "../publisher/PublisherLogo";
import { useMyPublishers } from "@seabrookstudios/pitch2table";
import { SelectableListEntriesDialog } from "./SelectableListEntriesDialog";
import { FilterablePublishersList } from "../publishers/FilterablePublishersList";
import { Path } from "../Path";
import { ArrowListItem } from "./ArrowListItem";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PublisherId[]} props.value - Selected publisher IDs
 * @param {function(import("@seabrookstudios/pitch2table-core").PublisherId[]): void} props.onChange - Callback when selection changes
 * @param {boolean} [props.single]
 */
export const SelectPublishersDialog = ({ value = [], onChange, single = false }) => {
  const { data: allPublishers = [], isLoading } = useMyPublishers();
  const [selectedPublishers, setSelectedPublishers] = useState(value);

  /**
   * @param {import("@seabrookstudios/pitch2table-core").PublisherId} publisherId
   */
  const handleTogglePublisher = (publisherId) => {
    if (single) {
      onChange([publisherId]);
      return;
    }

    setSelectedPublishers((current) => {
      if (current.includes(publisherId)) {
        return current.filter((id) => id !== publisherId);
      }
      return [...current, publisherId];
    });
  };

  const handleSave = () => {
    onChange(selectedPublishers);
  };

  const OnAddOverlay = () => (
    <FilterablePublishersList
      publishers={allPublishers}
      selectedPublishers={selectedPublishers}
      onTogglePublisher={handleTogglePublisher}
    />
  );

  const selectedPublisherObjects = allPublishers.filter((publisher) => selectedPublishers.includes(publisher.id));
  return (
    <SelectableListEntriesDialog
      title="Select Publishers"
      handleSave={handleSave}
      OnAddOverlay={OnAddOverlay}
      isLoading={isLoading}
    >
      {selectedPublisherObjects.map((publisher) => (
        <ArrowListItem
          key={publisher.id}
          to={Path.publisher(publisher.id).link()}
          primary={publisher.name}
          Left={() => <PublisherLogoSquare2 publisher={publisher} width={48} height={48} />}
        />
      ))}
    </SelectableListEntriesDialog>
  );
};
